<div class="table">
  <div class="cardPic">
    <div class="picture">
      <img *ngIf="imageFound" id="display" [src]="imageToShow" alt="logo"/>
      <p class="txtcenter" *ngIf="!imageFound">{{ preferenceMessages.tab_3_label_3 | translate }}</p>
    </div>
  </div>
  <div *ngIf="isGestionComptesAnnonceur" class="card">
    <label for="fichier" class="bold txtcenter required">{{ preferenceMessages.tab_3_label_2 | translate }}</label>
    <div class="containerLogo">
      <input type="file" id="fichier" accept=".jpg, .png, .bmp, .jpeg" (click)="$event.target.value = null" (change)="envoiFichier($event.target.files)" />
      <h3>{{ preferenceMessages.tab_3_label_5 | translate }}</h3>
      <label for="fileDropRef">
        <div *ngIf="imageFound" id="etiquette-group">
          <span class="text-etiquette">{{imageName}}</span>
          <div class="icon-etiquette">
            <mat-icon class="icon" (click)="delete()">highlight_off</mat-icon>
          </div>
        </div>
        <span class="text-boutton" *ngIf="!imageFound">{{ preferenceMessages.tab_3_label_4 | translate }}</span>
      </label>
      <div>
        <span *ngIf="errorBigImage" class="text-danger mt-1">{{ preferenceMessages.tab_3_error_1 | translate }}</span>
        <span *ngIf="errorBadFormat" class="text-danger mt-1">{{ preferenceMessages.tab_3_error_2 | translate }}</span>
      </div>
    </div>
  </div>
</div>
